<template>
    <v-layout
            align-center
            wrap
    >
        <v-flex xs12>
            <v-select
                    :loading="loading"
                    :rules="required === undefined || required === false ? [] : selectRules"
                    :clearable="required === undefined || required === false"
                    :error-messages="errorMessages"
                    v-model="model"
                    :items="items"
                    :box="box===true"
                    :chips="multiple"
                    return-object
                    :label="label || 'Seleccionar Previsión'"
                    :multiple="multiple"
                    item-text="name"
                    item-value="id"
            >
                <template v-show="!multiple" v-slot:item="data">
                    <template v-if="typeof data.item !== 'object'">
                        <v-list-tile-content v-text="data.item"></v-list-tile-content>
                    </template>
                    <template v-else>
                        <v-list-tile-avatar class="pa-1" color="grey lighten-2">
                            <img style="border: 1px solid #ccc" v-if="data.item.logo" :src="data.item.logo">
                            <v-icon v-if="!data.item.logo">fa-image</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                            <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                        </v-list-tile-content>
                    </template>
                </template>
            </v-select>
        </v-flex>
    </v-layout>
</template>

<script>
    import {ApiUtils} from '@/utils/ApiUtils'
    import {mapMutations} from 'vuex'
    export default{
        name: 'InsuranceCompanySelector',
        props: ['onChange', 'multiple', 'box', 'label', 'value', 'required', 'errorMessages'],
        data(){
            return{
                selectRules: [
                  v => !!v || 'Campo obligatorio'
                ],
                items: [
                    {
                        id: null,
                        logo: "",
                        name: "Sin previsión",
                        disabled: true
                    }
                ],
                model: null,
                loading: false
            }
        },
        mounted(){
            this.loadCompanies()
        },
        methods: {
            ...mapMutations(['showSnackBar']),
            async loadCompanies(){
                var vm = this
                vm.loading = true
                const response = await ApiUtils.makeGet('public/companies/insurance')
                vm.loading = false
                if(!response.ok){
                    vm.showSnackBar('Ocurrió un error consultando isapres')
                    return
                }

                const json = await response.json()
                vm.items = json.result.companies.data
                vm.$nextTick(function(){
                    if(vm.value){
                        vm.model = vm.value
                    }
                })
            },
            onSignUpSuccess(user){

            }
        },
        watch:{
            model(val){
                var vm = this
                if(typeof vm.onChange == 'function'){
                    vm.onChange(val)
                }
            },
            value(val){
                this.model = val
            }
        }
    }
</script>